// Module-level, ref-counted rather than a plain add/remove pair - two
// Button instances can be `loading` at once (e.g. a page action plus a
// background save), and a naive "remove the class in my own cleanup"
// would reset the cursor the moment the FIRST one finishes even though
// the second is still in flight. Counting instead of toggling means the
// class only comes off once nothing is busy anymore.
let busyCount = 0;

export const pushBusyCursor = () => {
  busyCount += 1;
  document.body.classList.add("app-busy");
};

export const popBusyCursor = () => {
  busyCount = Math.max(0, busyCount - 1);
  if (busyCount === 0) {
    document.body.classList.remove("app-busy");
  }
};
